export type ButtonDropdownProps = {
  id: string;
  title: string;
  icon?: string;
  desc?: string;
  href: string;
  type?: 'icon' | 'desc' | 'normal';
  items?: ButtonDropdownProps[];
  childrenUrls?: string[];
};

export type PopOverProps = {
  id: string;
  title: string;
  href?: string;
  childrenUrls?: string[];
  items?: ButtonDropdownProps[];
};

export const headerData: PopOverProps[] = [
  {
    id: 'p1',
    title: 'service',
    href: '/service/aha-delivery',
    childrenUrls: [
      '/service/aha-delivery',
      '/service/aha-delivery/price',
      '/service/aha-truck',
      '/service/aha-truck/price',
      '/service/cooperate',
      '/service/cooperate/onwheel',
      '/service/cooperate/warehouse',
      '/service/cooperate/fulfillment',
    ],
    items: [
      {
        id: 'p1c1',
        title: 'Dịch vụ giao hàng',
        type: 'icon',
        icon: '/static/icons/AhaShip.svg',
        href: '/service/aha-delivery',
        childrenUrls: ['/service/aha-delivery/price'],
      },
      {
        id: 'p1c3',
        title: 'Dịch vụ xe tải',
        type: 'icon',
        icon: '/static/icons/AhaTruck.svg',
        href: '/service/aha-truck',
        childrenUrls: ['/service/aha-truck/price'],
      },
      {
        id: 'p1c4',
        title: 'Dịch vụ doanh nghiệp',
        icon: '/static/icons/AhaSupply.svg',
        type: 'icon',
        href: '/service/cooperate',
        childrenUrls: [
          '/service/cooperate/onwheel',
          '/service/cooperate/warehouse',
          '/service/cooperate/fulfillment',
        ],
        items: [
          {
            id: 'p1c4c1',
            type: 'normal',
            title: 'SaaS / OnWheel',
            href: '/service/cooperate/onwheel',
          },
          {
            id: 'p1c4c2',
            type: 'normal',
            title: 'Warehouse',
            href: '/service/cooperate/warehouse',
          },
          {
            id: 'p1c4c3',
            type: 'normal',
            title: 'Fulfillment',
            href: '/service/cooperate/fulfillment',
          },
        ],
      },
    ],
  },
  {
    id: 'p2',
    title: 'customer',
    href: '/customer/merchant',
    childrenUrls: [
      '/customer/merchant',
      '/customer/cooperate',
      '/customer/help-center',
    ],
    items: [
      {
        id: 'p2c1',
        title: 'Khách hàng cá nhân',
        type: 'normal',
        href: '/customer/merchant',
      },
      {
        id: 'p2c2',
        title: 'Khách hàng doanh nghiệp',
        type: 'normal',
        href: '/customer/cooperate',
      },
      {
        id: 'p2c3',
        title: 'Cộng đồng khách hàng',
        type: 'normal',
        href: 'https://www.facebook.com/groups/1913817152225236/',
      },
      {
        id: 'p2c4',
        title: 'Trung tâm hỗ trợ',
        type: 'normal',
        href: '/customer/help-center',
      },
    ],
  },
  {
    id: 'p3',
    title: 'driver',
    href: '/driver',
    childrenUrls: [
      '/driver',
      '/tin-tuc?category=tai-xe',
      '/driver/handbook',
      '/driver/help-center',
    ],
    items: [
      {
        id: 'p3c1',
        title: 'Đăng ký tài xế mới',
        type: 'normal',
        href: '/driver',
      },
      {
        id: 'p3c2',
        title: 'Cộng đồng tài xế',
        type: 'normal',
        href: '/tai-xe-ahamove',
      },
      {
        id: 'p3c3',
        title: 'Cẩm nang tài xế',
        type: 'normal',
        href: '/so-tay-truc-tuyen-danh-cho-doi-tac-ahamove',
      },
      {
        id: 'p3c4',
        title: 'Trung tâm hỗ trợ',
        type: 'normal',
        href: '/driver/help-center',
      },
    ],
  },
  {
    id: 'p4',
    title: 'recruitment',
    href: '/recruitment',
    childrenUrls: [
      '/about-us',
      '/ahamover-story',
      '/job',
      '/recruitment',
      '/apprentice-program',
    ],
    items: [
      {
        id: 'p4c1',
        title: 'Về chúng tôi',
        type: 'normal',
        href: '/about-us',
      },
      {
        id: 'p4c2',
        title: 'Câu chuyện Ahamovers',
        type: 'normal',
        href: '/ahamover-story',
      },
      {
        id: 'p4c3',
        title: 'Gia nhập Ahamove ngay',
        type: 'normal',
        href: '/recruitment',
      },
      // {
      //   id: 'p4c4',
      //   title: 'Chương trình AhaFuture2024',
      //   type: 'normal',
      //   href: '/internship-program',
      // },
    ],
  },
  {
    id: 'p5',
    title: 'blog',
    href: '/blog',
    childrenUrls: ['/blog', '/report', 'tin-tuc'],
    items: [
      {
        id: 'p5c1',
        title: 'Tin tức',
        type: 'normal',
        href: '/tin-tuc',
        desc: 'Cung cấp thông tin mới nhất',
      },
      {
        id: 'p5c3',
        title: 'Blog',
        type: 'normal',
        href: '/blog',
        desc: 'Chuyên cung cấp đầy đủ thông tin hữu ích',
      },
      {
        id: 'p5c2',
        title: 'Báo cáo',
        type: 'normal',
        href: '/report',
      },
    ],
  },
];

const isDev = process.env.NODE_ENV === 'development';

export const headerDataKinhDoanh: PopOverProps[] = [
  {
    id: 'p1',
    title: 'businessExperience',
    href: `${isDev ? '/kinhdoanh' : ''}/kinh-nghiem-kinh-doanh`,
    childrenUrls: [
      `${
        isDev ? '/kinhdoanh' : ''
      }/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang`,
      `${isDev ? '/kinhdoanh' : ''}/kinh-nghiem-kinh-doanh/ban-hang-online`,
      `${
        isDev ? '/kinhdoanh' : ''
      }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook`,
      `${
        isDev ? '/kinhdoanh' : ''
      }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee`,
      `${
        isDev ? '/kinhdoanh' : ''
      }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop`,
      `${
        isDev ? '/kinhdoanh' : ''
      }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada`,
      `${isDev ? '/kinhdoanh' : ''}/kinh-nghiem-kinh-doanh/kien-thuc-marketing`,
    ],
    items: [
      {
        id: 'p1c1',
        title: 'Kinh nghiệm mở cửa hàng',
        type: 'normal',
        icon: '/static/icons/AhaShip.svg',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang`,
      },
      {
        id: 'p1c2',
        title: 'Bán hàng online',
        type: 'normal',
        icon: '/static/icons/AhaTruck.svg',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/ban-hang-online`,
      },
      {
        id: 'p1c3',
        title: 'Kinh doanh trên Facebook',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook`,
      },
      {
        id: 'p1c4',
        title: 'Kinh doanh trên Shopee',
        type: 'normal',
        icon: '/static/icons/AhaShip.svg',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee`,
      },
      {
        id: 'p1c5',
        title: 'Kinh doanh trên TikTok Shop',
        type: 'normal',
        icon: '/static/icons/AhaTruck.svg',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop`,
      },
      {
        id: 'p1c6',
        title: 'Kinh doanh trên Lazada',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada`,
      },
      {
        id: 'p1c7',
        title: 'Kinh doanh trên Lazada',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada`,
      },
      {
        id: 'p1c8',
        title: 'Kiến thức Marketing',
        icon: '/static/icons/AhaSupply.svg',
        type: 'normal',
        href: `${
          isDev ? '/kinhdoanh' : ''
        }/kinh-nghiem-kinh-doanh/kien-thuc-marketing`,
      },
    ],
  },
  {
    id: 'p2',
    title: 'businessIdeas',
    href: `${isDev ? '/kinhdoanh' : ''}/y-tuong-kinh-doanh`,
  },
  {
    id: 'p3',
    title: 'goodsSource',
    href: `${isDev ? '/kinhdoanh' : ''}/nguon-hang`,
    childrenUrls: [
      `${isDev ? '/kinhdoanh' : ''}/nguon-hang/cho-dau-moi',
      '/kinh-doanh/nguon-hang/cach-nhap-hang`,
    ],
    items: [
      {
        id: 'p3c1',
        title: 'Chợ đầu mối',
        type: 'normal',
        href: `${isDev ? '/kinhdoanh' : ''}/nguon-hang/cho-dau-moi`,
      },
      {
        id: 'p3c2',
        title: 'Cách nhập hàng',
        type: 'normal',
        href: `${isDev ? '/kinhdoanh' : ''}/nguon-hang/cach-nhap-hang`,
      },
    ],
  },
  {
    id: 'p4',
    title: 'warehouse',
    href: `${isDev ? '/kinhdoanh' : ''}/kho-bai`,
  },
];
